import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import AboutOne from '../components/sections/AboutOne';
import ServiceSecOne from '../components/sections/ServiceSecOne';
import BrandOne from '../components/sections/BrandOne';
import WhySecTwo from '../components/sections/WhySecTwo';
import ProcessSecOne from '../components/sections/ProcessSecOne';
import TeamSecOne from '../components/sections/TeamSecOne';
import TestiSecThree from '../components/sections/TestiSecThree';

const About = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.about.title" subtitleKey="sections.breadcrumb.about.subtitle" />
        <AboutOne />
        <ServiceSecOne className="overflow-hidden space-bottom" />
        <BrandOne className="bg-smoke pt-60 pb-60" />
        <WhySecTwo className="space overflow-hidden" />
        <ProcessSecOne className="space-bottom overflow-hidden" />
        <TeamSecOne className="space bg-smoke overflow-hidden" />
        <TestiSecThree className="space overflow-hidden" />
        
      <Footer />
    </>
  );
};

export default About;